export default __webpack_public_path__ + "static/media/TriaLogo_White.d5fc51c4.svg";